exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".legend {\r\n  top: 80px;\r\n  left: 20px;\r\n  width: auto;\r\n  position: absolute;\r\n  pointer-events: auto; }\r\n\r\n.legend_item {\r\n  padding: 2px 0; }\r\n\r\n.legend_item_name {\r\n  font-size: 12px;\r\n  display: inline-block;\r\n  padding: 0 5px;\r\n  vertical-align: top;\r\n  line-height: 18px; }\r\n\r\n.legend_clr {\r\n  width: 18px;\r\n  height: 18px;\r\n  background-color: #4E40D8;\r\n  border-radius: 3px;\r\n  display: inline-block; }\r\n\r\n@media only screen and (max-width: 600px) {\r\n  .legend {\r\n    display: none; } }\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/scenes/MapContainer/components/Legend/Legend.css
// module id = 841
// module chunks = 0